export * from './services/SharePointService';

//# sourceMappingURL=SharePointService.js.map
